/** Default wishlist name — must match backend list name used with AddItemToWishList / GetWishListItems */
export const DEFAULT_WISHLIST_NAME = 'Favorites';
